export const experimentWin = payload => {
  return {
    type: 'EXPERIMENT_WIN',
    payload: {
      ...payload,
      status: 'win',
    },
  };
};
